
import { ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

type RouteGuardProps = {
  children: ReactNode;
};

export const AuthRouteGuard = ({ children }: RouteGuardProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    if (!loading) {
      setIsCheckingAuth(false);
    }
  }, [loading]);

  if (isCheckingAuth) {
    // Show a minimal loading state while checking authentication
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <div className="animate-spin h-8 w-8 border-4 border-clustr-blue border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!user) {
    // Redirect to the login page if not authenticated
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export const PublicRouteGuard = ({ children }: RouteGuardProps) => {
  const { user, loading } = useAuth();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    if (!loading) {
      setIsCheckingAuth(false);
    }
  }, [loading]);

  if (isCheckingAuth) {
    // Show a minimal loading state while checking authentication
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <div className="animate-spin h-8 w-8 border-4 border-clustr-blue border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (user) {
    // Redirect to dashboard if already authenticated
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
